import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login',
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    ...mapActions(['getLoginUrl']),
    async handleLoginCognito () {
      const { url } = await this.getLoginUrl()

      if (url) {
        window.location.href = url
      }
    }
  }
}
